import React, { useState } from "react";
import "./DashboardpagesCss/MyHealth.css";
import nodatafound from "../../Assets/noDataFound.png"; // 👈 Use your existing image

const MyHealth = () => {
  const [showAllPast, setShowAllPast] = useState(false);
  const [showAllCurrent, setShowAllCurrent] = useState(false);

  const pastMedications = [
    {
      name: "Ibuprofen 200mg",
      completedDate: "02 Sep 2025",
      doctor: "Dr. Sharma",
    },
    {
      name: "Vitamin D3 Supplements",
      completedDate: "10 Aug 2025",
      doctor: "Dr. Sen",
    },
    {
      name: "Aspirin 100mg",
      completedDate: "01 Jul 2025",
      doctor: "Dr. Khan",
    },
    {
      name: "Cetrizine 10mg",
      completedDate: "22 Jun 2025",
      doctor: "Dr. Roy",
    },
  ];

  const currentMedications = [
    {
      name: "Paracetamol 500mg",
      dosage: "1 tablet twice daily after meals",
      doctor: "Dr. Roy",
    },
    {
      name: "Amoxicillin 250mg",
      dosage: "1 capsule thrice daily",
      doctor: "Dr. Smith",
    },
  ];

  const healthReports = [
    { title: "Blood Test Report", date: "10 Sep 2025" },
    { title: "X-Ray Scan", date: "05 Aug 2025" },
    { title: "ECG Report", date: "28 Jul 2025" },
    { title: "ECG Report", date: "28 Jul 2025" },
    { title: "ECG Report", date: "28 Jul 2025" },
  ];

  return (
    <div className="container">
      <div className="profile-header">
        <h2>My Health</h2>
      </div>

      {/* --- Past & Current Medications --- */}
      <div className="health-sections">
        {/* --- Past Medication --- */}
        <div className="doctor-list-card">
          <div className="doctorTopSec">
            <h3>Past Medication</h3>
          </div>

          {pastMedications.length === 0 ? (
            <div className="no-data">
              <img src={nodatafound} alt="No Data Found" />
            </div>
          ) : (
            <>
              <ul className="list-group">
                {(showAllPast ? pastMedications : pastMedications.slice(0, 3)).map(
                  (item, index) => (
                    <li className="list-group-item" key={index}>
                      <div className="med-info">
                        <h4>{item.name}</h4>
                        <p>Completed: {item.completedDate}</p>
                        <p>Prescribed by: {item.doctor}</p>
                      </div>
                    </li>
                  )
                )}
              </ul>

              {pastMedications.length > 3 && (
                <button
                  className="rbdButton"
                  onClick={() => setShowAllPast(!showAllPast)}
                >
                  <span className="btn-text">
                    {showAllPast ? "View Less" : "View More"}
                  </span>
                </button>
              )}
            </>
          )}
        </div>

        {/* --- Current Medication --- */}
        <div className="doctor-list-card">
          <div className="doctorTopSec">
            <h3>Current Medication</h3>
          </div>

          {currentMedications.length === 0 ? (
            <div className="no-data">
              <img src={nodatafound} alt="No Data Found" />
            </div>
          ) : (
            <>
              <ul className="list-group">
                {(
                  showAllCurrent
                    ? currentMedications
                    : currentMedications.slice(0, 3)
                ).map((item, index) => (
                  <li className="list-group-item" key={index}>
                    <div className="med-info">
                      <h4>{item.name}</h4>
                      <p>Dosage: {item.dosage}</p>
                      <p>Prescribed by: {item.doctor}</p>
                    </div>
                  </li>
                ))}
              </ul>

              {currentMedications.length > 3 && (
                <button
                  className="rbdButton"
                  onClick={() => setShowAllCurrent(!showAllCurrent)}
                >
                  <span className="btn-text">
                    {showAllCurrent ? "View Less" : "View More"}
                  </span>
                </button>
              )}
            </>
          )}
        </div>
      </div>

      {/* --- Health Reports --- */}
      <div className="health-section">
        <div className="doctorTopSec">
          <h3>Health Reports</h3>
        </div>

        {healthReports.length === 0 ? (
          <div className="no-data">
            <img src={nodatafound} alt="No Data Found" />
          </div>
        ) : (
          <div className="report-list">
            {healthReports.map((report, index) => (
              <div className="report-card" key={index}>
                <h4>{report.title}</h4>
                <p>Date: {report.date}</p>
                <button className="rbdButton"> <span className="btn-text">View Report</span> </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyHealth;
